import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';

import HomePage from './HomePage';
import PrivacyPolicy from './PrivacyPolicy';
import EcommercePage from './EcommercePage';
import DemosPage from './DemosPage';
import CustomerTimelinePage from './demos/CustomerTimelinePage';
import CallExpectationsPage from './CallExpectationsPage';
import LinusTseIntroductionPage from './LinusTseIntroductionPage';
import CaseStudiesIndex from './casestudies/CaseStudiesIndex';
import CaseStudyPage from './casestudies/CaseStudyPage';
import BlogIndex from './blog/BlogIndex';
import MendelsohnInterview from './blog/MendelsohnInterview';
import Snowflake from './blog/Snowflake';
import TableauVsPowerBI from './blog/TableauVsPowerBI';
import FivetranVsAirbyteVsDatonEcommerce from './blog/FivetranVsAirbyteVsDatonEcommerce';
import PowerBIVsTableauEcommerce from './blog/PowerBIVsTableauEcommerce';
import BigQueryVsSnowflakeEcommerce from './blog/BigQueryVsSnowflakeEcommerce';
import BlogPost from './blog/BlogPost';
import SnowflakeConsultingPage from './services/SnowflakeConsultingPage';
import SigmaConsultingPage from './services/SigmaConsultingPage';
import MigrationPage from './services/MigrationPage';
import CompareIndex from './compare/CompareIndex';
import ComparePage from './compare/ComparePage';
import NotFoundPage from './NotFoundPage';
import ResourcesIndex from './resources/ResourcesIndex';
import TopicHub from './resources/TopicHub';
import ReportingCalculatorPage from './tools/ReportingCalculatorPage';
import MigrationReadinessPage from './tools/MigrationReadinessPage';
import FormulaTranslatorPage from './tools/FormulaTranslatorPage';
import RetentionValuePage from './tools/RetentionValuePage';
import ToolQuizPage from './tools/ToolQuizPage';
import StackQuizPage from './tools/StackQuizPage';
import MigrationAssessmentPage from './tools/MigrationAssessmentPage';
import WhitePaperPage from './whitePapers/WhitePaperPage';
import ContactPage from './ContactPage';

function ScrollToHash() {
  const { hash, pathname } = useLocation();

  React.useEffect(() => {
    if (hash) {
      document.getElementById(hash.slice(1))?.scrollIntoView();
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [hash, pathname]);

  return null;
}

function App() {
  return (
    <>
      <ScrollToHash />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/ecommerce" element={<EcommercePage />} />
        <Route path="/services/snowflake-consulting" element={<SnowflakeConsultingPage />} />
        <Route path="/services/tableau-to-sigma" element={<MigrationPage source="tableau" />} />
        <Route path="/services/power-bi-to-sigma" element={<MigrationPage source="powerbi" />} />
        <Route path="/services/sigma-consulting" element={<SigmaConsultingPage />} />
        <Route path="/demos" element={<DemosPage />} />
        <Route path="/demos/customer-timeline" element={<CustomerTimelinePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/call-expectations" element={<CallExpectationsPage />} />
        <Route path="/linus-tse-introduction" element={<LinusTseIntroductionPage />} />
        <Route path="/case-studies" element={<CaseStudiesIndex />} />
        <Route path="/case-studies/:slug" element={<CaseStudyPage />} />
        <Route path="/resources" element={<ResourcesIndex />} />
        <Route path="/resources/:topic" element={<TopicHub />} />
        <Route path="/tools/reporting-time-calculator" element={<ReportingCalculatorPage />} />
        <Route path="/tools/sigma-migration-readiness" element={<MigrationReadinessPage />} />
        <Route path="/tools/tableau-to-sigma-formula-translator" element={<FormulaTranslatorPage variant="tableau" />} />
        <Route path="/tools/dax-to-sigma-formula-translator" element={<FormulaTranslatorPage variant="dax" />} />
        <Route path="/tools/retention-value-calculator" element={<RetentionValuePage />} />
        <Route path="/tools/ecommerce-analytics-tool-quiz" element={<ToolQuizPage variant="ecommerce" />} />
        <Route path="/tools/bi-tool-quiz" element={<ToolQuizPage variant="bi" />} />
        <Route path="/tools/ecommerce-data-stack-quiz" element={<StackQuizPage />} />
        <Route path="/tools/tableau-to-sigma-migration-assessment" element={<MigrationAssessmentPage source="tableau" />} />
        <Route path="/tools/power-bi-to-sigma-migration-assessment" element={<MigrationAssessmentPage source="powerbi" />} />
        <Route path="/white-papers/ecommerce-data-stack" element={<WhitePaperPage slug="ecommerce-data-stack" />} />
        <Route path="/white-papers/customer-retention-reporting" element={<WhitePaperPage slug="customer-retention-reporting" />} />
        <Route path="/compare" element={<CompareIndex />} />
        <Route path="/compare/:slug" element={<ComparePage />} />
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/sales-engineer-interview" element={<MendelsohnInterview />} />
        <Route path="/blog/snowflake-explained" element={<Snowflake />} />
        <Route path="/blog/tableau-vs-powerbi" element={<TableauVsPowerBI />} />
        <Route path="/blog/fivetran-vs-airbyte-vs-daton-ecommerce" element={<FivetranVsAirbyteVsDatonEcommerce />} />
        <Route path="/blog/power-bi-vs-tableau-ecommerce" element={<PowerBIVsTableauEcommerce />} />
        <Route path="/blog/bigquery-vs-snowflake-ecommerce" element={<BigQueryVsSnowflakeEcommerce />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

export default App;
